/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} WorkspacesInputs */



/**
* | output |
* | --- |
* | "Workspaces" |
*
* @param {WorkspacesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const workspaces = /** @type {((inputs?: WorkspacesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<WorkspacesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Espaces de travail")
	if (locale === "de") return /** @type {LocalizedString} */ ("Arbeitsbereiche")
	if (locale === "it") return /** @type {LocalizedString} */ ("Spazi di lavoro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Рабочие места")
	if (locale === "es") return /** @type {LocalizedString} */ ("Espacios de trabajo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("工作区")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ワークスペース")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्यस्थानों")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Espaços de trabalho")
	return /** @type {LocalizedString} */ ("Workspaces")
});